import React from 'react';
import PropTypes from 'prop-types';
import { Column, Container, Row, Section } from 'components/atoms';
import { NavUnit } from 'components/molecules';

import './SecondaryNav.scss';

const nav = [	
	{
		title: "5' x 5'",
		href: '/storage-unit-size-guide/5x5-storage-unit.html',
	},
	{
		title: '5’ x 10’',
		href: '/storage-unit-size-guide/5x10-storage-unit.html',
	},
	{
		title: '5’ x 15’',
		href: '/storage-unit-size-guide/5x15-storage-unit.html',
	},
	{
		title: '10’ x 10’',
		href: '/storage-unit-size-guide/10x10-storage-unit.html',
	},
	{
		title: '10’ x 15’',
		href: '/storage-unit-size-guide/10x15-storage-unit.html',
	},
	{
		title: '10’ x 20’',
		href: '/storage-unit-size-guide/10x20-storage-unit.html',
	},
	{
		title: '10’ x 25’',
		href: '/storage-unit-size-guide/10x25-storage-unit.html',
	},
	{
		title: '10’ x 30’',
		href: '/storage-unit-size-guide/10x30-storage-unit.html',
	},
	{
		title: 'Mini Storage',
		href: '/storage-unit-size-guide/mini-storage.html',
	},
	{
		title: 'Storage Lockers',
		href: '/storage-unit-size-guide/storage-lockers.html',
	},
];

const SecondaryNav = ({active}) => {
	
	return (
		<Section className="sectionSecondaryNav">
			<Container>
				<Row>
					<Column>
						<NavUnit nav={nav} active={active} />
					</Column>
				</Row>
			</Container>
		</Section>
	);
};

SecondaryNav.propTypes = {
	active: PropTypes.string,	
};

export default SecondaryNav;
